"use client";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { useSession } from "next-auth/react";
import { useEffect, useState } from "react";
import AnalyticsPageStats from "~/components/analytics/AnalyticsPageStats";
import { adminBlogAnalyticsService } from "~/connectors/blog.connector";
import type { BlogPageStats } from "~/types";

interface Props {
  slug: string;
}

export default function AdminBlogPageStats({ slug }: Props) {
  const { data: session } = useSession();
  const isAdmin = session?.user?.role === "admin";

  const [stats, setStats] = useState<BlogPageStats | null>(null);
  const [loading, setLoading] = useState(false);

  const [periodStart] = useState(() => new Date(Date.now() - 30 * 24 * 60 * 60 * 1000));

  useEffect(() => {
    if (!isAdmin) return;

    setTimeout(() => setLoading(true), 0);
    adminBlogAnalyticsService
      .getPageStats({ slug, startAt: periodStart })
      .then((data) => setStats(data))
      .catch(() => setStats(null))
      .finally(() => setLoading(false));
  }, [isAdmin, slug, periodStart]);

  if (!isAdmin) return null;

  if (loading) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
        <CircularProgress size={14} />
        <Typography variant="caption" sx={{
          color: "text.secondary"
        }}>
          Se încarcă statisticile...
        </Typography>
      </Box>
    );
  }

  if (!stats) return null;

  return <AnalyticsPageStats stats={stats} periodStart={periodStart} />;
}
